export default "__VITE_ASSET__D82i6M5E__"